export default __webpack_public_path__ + "static/media/loadingGif_transparent.fe5ee949.gif";